import * as React from 'react';

import CommentView from './comment-view.component';

const CommentContainer = () => <CommentView />;
export default CommentContainer;
